<div class="container-fluid">
  <div class="form-horizontal">
    <div class="form-group">
      <div class="col-sm-12">
        <h3>{{ 'events.registration.wizard.sponsor.title' | translate | titlecase }}</h3>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-12">
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="_invertedDoNotDisplay" (ngModelChange)="handleInvertedDoNotDisplayChange($event)" />
            {{ 'events.registration.wizard.sponsor.show-sponsor-logo-label' | translate | titlecase }}
          </label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-3">
        <label>
          {{ 'events.registration.wizard.sponsor.sponsor-name-label' | translate | titlecase }}
        </label>
      </div>
      <div class="col-sm-9">
        <input type="text" [(ngModel)]="sponsor.SponsorName" class="form-control" />
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3">
        <label>
          {{ 'events.registration.wizard.sponsor.sponsor-image-label' | translate | titlecase }}
        </label>
      </div>
      <div class="col-sm-9">
        <wl-image-lookup
          #sponsorImageSelector
          [(ngModel)]="sponsor.SponsorLogoUrl"
          [profileId]="registration.Registration.ProfileId"
        ></wl-image-lookup>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-3">
        <label>
          {{ 'events.registration.wizard.sponsor.sponsor-message-label' | translate | titlecase }}
        </label>
      </div>
      <div class="col-sm-9">
        <textarea class="form-control" [(ngModel)]="sponsor.SponsorMessage"></textarea>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-3">
        <label>
          {{ 'events.registration.wizard.sponsor.sponsor-website-label' | translate | titlecase }}
        </label>
      </div>
      <div class="col-sm-9">
        <input type="url" class="form-control" [(ngModel)]="sponsor.SponsorWebsite" />
      </div>
    </div>
  </div>
</div>
